import type { RecordListItemDTO } from "@/application/records/dtos/RecordListItemDTO";
import type { RecordsGatewayPort } from "@/application/records/ports/RecordsGatewayPort";

export interface FetchRecordsListInputDto {
  limit?: number;
}

/**
 * Use case: загрузка полного списка записей для текущего пользователя.
 */
export class FetchRecordsListUseCase {
  constructor(private readonly gateway: RecordsGatewayPort) {}

  async execute(
    input: FetchRecordsListInputDto = {}
  ): Promise<RecordListItemDTO[]> {
    return this.gateway.getRecordsList(input.limit);
  }
}
